import './page/acris-blog-create';
import './page/acris-blog-detail';
import './page/acris-blog-list';

const { Module } = Shopware;

Module.register('acris-blog', {
    type: 'plugin',
    name: 'AcrisBlog',
    title: 'acris-blog.general.mainMenuItemGeneral',
    version: '1.0.0',
    targetVersion: '1.0.0',
    color: '#a6c836',
    icon: 'regular-content',
    favicon: 'icon-module-settings.png',

    routes: {
        index: {
            component: 'acris-blog-list',
            path: 'index',
            meta: {
                parentPath: 'acris.blogs.index'
            }
        },
        detail: {
            component: 'acris-blog-detail',
            path: 'detail/:id',
            meta: {
                parentPath: 'acris.blog.index'
            }
        },
        create: {
            component: 'acris-blog-create',
            path: 'create',
            meta: {
                parentPath: 'acris.blog.index'
            }
        }
    },

    navigation: [{
        id: 'acris-blog',
        label: 'acris-blog.general.mainMenuItemGeneral',
        path: 'acris.blog.index',
        position: 100,
        parent: 'sw-content'
    }]
});
